export const loadState = (item: string): any => {
  try {
    const serialState: any = localStorage.getItem(item);

    if (serialState === null) {
      return undefined;
    }

    return JSON.parse(serialState);
  } catch (err) {
    console.log(err);

    return undefined;
  }
};

export const saveState = (item: string, state: any) => {
  try {
    if (state === null) {
      localStorage.removeItem(item);
      return;
    }

    const serialState = JSON.stringify(state);

    localStorage.setItem(item, serialState);
  } catch (err) {
    console.log(err);
  }
};
